export const fonts = {
  BentonSansWideBlack: "BentonSansWideBlack",
  BentonSansWideMedium: "BentonSansWideMedium",
  BentonSansWideRegular: "BentonSansWideRegular",
  BentonSansBold: "BentonSansBold",
  BentonSansMedium: "BentonSansMedium",
  BentonSansRegular: "BentonSansRegular",
  BentonSansLight: "BentonSansLight",
  BentonSansBookItalic: "BentonSansBookItalic",
  EditorialNewRegular: "EditorialNewRegular",
  EditorialNewUltraBold: "EditorialNewUltraBold",
};
